import {
  DISTRICT_LOGO_KEY,
  DISTRICT_SESSION_ID_KEY,
  DISTRICT_SESSION_KEY,
  PersistedDistrictSession,
} from './types'

// --- Pre-login (sessionStorage): cached address + matched district so the
//     visitor doesn't re-enter their address every time they hit the page.

export const readDistrictSession = (): PersistedDistrictSession | null => {
  try {
    const raw = sessionStorage.getItem(DISTRICT_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as PersistedDistrictSession
  } catch (e) {
    return null
  }
}

export const writeDistrictSession = (session: PersistedDistrictSession): void => {
  try {
    sessionStorage.setItem(DISTRICT_SESSION_KEY, JSON.stringify(session))
  } catch (e) {
    // ignore
  }
}

export const clearDistrictSession = (): void => {
  try {
    sessionStorage.removeItem(DISTRICT_SESSION_KEY)
    sessionStorage.removeItem(DISTRICT_SESSION_ID_KEY)
  } catch (e) {
    // ignore
  }
}

// --- Post-login (localStorage): district number persisted across the auth
//     redirect so the navbar logo override can look up the senator's brand
//     logo on every page load.

export const writeDistrictLogoKey = (ilSenateDistrict: number | null): void => {
  try {
    if (ilSenateDistrict == null || !Number.isFinite(ilSenateDistrict)) {
      localStorage.removeItem(DISTRICT_LOGO_KEY)
      return
    }
    localStorage.setItem(DISTRICT_LOGO_KEY, String(ilSenateDistrict))
  } catch (e) {
    // ignore
  }
}

export const readDistrictLogoKey = (): number | null => {
  try {
    const raw = localStorage.getItem(DISTRICT_LOGO_KEY)
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch (e) {
    return null
  }
}

export const clearDistrictLogoKey = (): void => {
  try {
    localStorage.removeItem(DISTRICT_LOGO_KEY)
  } catch (e) {
    // ignore
  }
}
